module.exports = __webpack_public_path__ + "img/logo_lockup_analytics_icon_vertical_black_2x.f84c710c.png";